import './index.scss';
import '../../translations/i18n';
import React, { useState } from 'react';
import { ISharedProps } from '../../models/interfaces';
import BillingCycle from '../BillingCycle';
import { useTranslation } from 'react-i18next';
import OtherServicesSection from '../OtherServicesSection';
import { Callout, IconCalendarEuroRegular, ButtonLink } from '@telefonica/mistica';
import { getFormatDate } from '../../utils/dataTransformation/dateConversions';
import { CardsHome } from '../CardsFlexHome';

const OnlyFiber: React.FC<ISharedProps> = (dataTab: any) => {
    const { t } = useTranslation();
    const [billing] = useState(dataTab.dataTab.cycleEnded);

    return (
        <div className='only-fiber'>
            {billing && (
                <div className='only-fiber__callout'>
                    <Callout
                        icon={<IconCalendarEuroRegular />}
                        title={t('consumptionInformation')}
                        description={t('consumptionInformationDescription')}
                        buttonLink={<ButtonLink onPress={() => {}}>{t('moreInformation')}</ButtonLink>}
                    />
                </div>
            )}
            <div className='only-fiber__otherServices'>
                <OtherServicesSection
                    dataTab={dataTab.dataTab}
                    BillingCycle={`${dataTab.dataTab.cycleStarts} - ${dataTab.dataTab.cycleEnds} `}
                    closing={`${dataTab.dataTab.cycleEndInDays} ` + t('day')}
                ></OtherServicesSection>
            </div>
            <div className='only-fiber__billingCycle'>
                <BillingCycle
                    BillingCycle={`${getFormatDate(dataTab.dataTab.cycleStarts, 'DD/MM')} - ${getFormatDate(
                        dataTab.dataTab.cycleEnds,
                        'DD/MM',
                    )} `}
                    closing={`${dataTab.dataTab.cycleEndInDays} ` + t('day')}
                ></BillingCycle>
            </div>
            <CardsHome product='fiber'></CardsHome>
        </div>
    );
};

export default OnlyFiber;
